import React, { useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import PropTypes from "prop-types";
import { FixIDS } from "../../../../utils/fixIDS";
import "./WidgetsDropdown.css";

import {
  CRow,
  CCol,
  CDropdown,
  CDropdownMenu,
  CDropdownItem,
  CDropdownToggle,
  CWidgetStatsA,
} from "@coreui/react";
import { getStyle } from "@coreui/utils";
import { CChartBar, CChartLine } from "@coreui/react-chartjs";
import CIcon from "@coreui/icons-react";
import { cilArrowBottom, cilArrowTop, cilOptions } from "@coreui/icons";
import { useDispatch, useSelector } from "react-redux";
import { dashboard } from "../../../../features/auth/Slice";
import { Link } from "react-router-dom";
import { IDS } from "../../../../utils/IDS";
import { GetAll } from "../../../../features/admin/role_permmission/owner/Slice";
import { Table, Form, FormLabel } from "react-bootstrap";
import Quick_Access from "./quick_access/Quick_Access";
import Banner from "../../../../common/banner/Banner";
import Recent_Activity_Feed from "./dashboard_other_components/recent_activity_feed/Recent_Activity_Feed";
import Recent_Transaction from "./dashboard_other_components/recent_transaction/Recent_Transaction";
// import Balance_Cards from "../dashboard-common-components/balance_cards/Balance_Cards";
import Balance_Cards from "./dashboard_other_components/balance_cards/Balance_Cards";

const WidgetsDropdown = (props) => {
  const widgetChartRef1 = useRef(null);
  const widgetChartRef2 = useRef(null);

  const Permissions = useSelector((state) => state.auth.permissions);

  useEffect(() => {
    document.documentElement.addEventListener("ColorSchemeChange", () => {
      if (widgetChartRef1.current) {
        setTimeout(() => {
          widgetChartRef1.current.data.datasets[0].pointBackgroundColor =
            getStyle("--cui-primary");
          widgetChartRef1.current.update();
        });
      }

      if (widgetChartRef2.current) {
        setTimeout(() => {
          widgetChartRef2.current.data.datasets[0].pointBackgroundColor =
            getStyle("--cui-info");
          widgetChartRef2.current.update();
        });
      }
    });
  }, [widgetChartRef1, widgetChartRef2]);

  const handleClick = (activityType) => {
    console.log("Activity clicked:", activityType);
  };

  const dispatch = useDispatch();

  const dashboardData = useSelector((state) => state.auth.all_dashboard);

  useEffect(() => {
    dispatch(dashboard());
  }, [dispatch]);

  const users = useSelector((state) => state.usermanagement.Owner);

  useEffect(() => {
    fetch();
  }, [dispatch]);

  const fetch = async (page = 1) => {
    // await dispatch(AllCountry());
    if (Permissions?.includes(FixIDS?.Country.Add)) {
      await dispatch(
        GetAll({
          role_id: IDS.User.Shopkeeper,
        })
      );
    }
  };

  return (
    <>


      {Permissions?.includes(FixIDS?.User.Add) ? (
        <>



          <CRow className={props.className} xs={{ gutter: 4 }}>
            <CCol sm={6} xl={4} xxl={3}>
              {/* <Link to="/user-management/owner"> */}
              <div
                className="bg-primary dashboard_box1 text-white rounded p-3 d-flex flex-column align-items-start shadow-sm"
                style={{ minHeight: "150px" }}
              >
                <div className="fs-4 fw-bold">
                  {dashboardData?.total_users || 0}
                </div>
                <div className="fs-6">Total Users</div>
              </div>
              {/* </Link> */}
            </CCol>

            <CCol sm={6} xl={4} xxl={3}>
              <Link to="/user-management/shopkeeper">
                <div
                  className="bg-success dashboard_box2 text-white rounded p-3 d-flex flex-column align-items-start shadow-sm"
                  style={{ minHeight: "150px" }}
                >
                  <div className="fs-4 fw-bold">
                    {dashboardData?.total_shopkeepers || 0}
                  </div>
                  <div className="fs-6">Total Shopkeepers</div>
                </div>
              </Link>
            </CCol>

            <CCol sm={6} xl={4} xxl={3}>
              <Link to="/user-management/vendor">
                <div
                  className="bg-warning text-dark dashboard_box3 text-white rounded p-3 d-flex flex-column align-items-start shadow-sm"
                  style={{ minHeight: "150px" }}
                >
                  <div className="fs-4 fw-bold">
                    {dashboardData?.total_vendors || 0}
                  </div>
                  <div className="fs-6">Total Vendors</div>
                </div>
              </Link>
            </CCol>

            <CCol sm={6} xl={4} xxl={3}>
              <Link to="/user-management/party">
                <div
                  className="bg-danger text-white dashboard_box4 rounded p-3 d-flex flex-column align-items-start shadow-sm"
                  style={{ minHeight: "150px" }}
                >
                  <div className="fs-4 fw-bold">{dashboardData?.total_parties}</div>
                  <div className="fs-6">Total Parties</div>
                </div>
              </Link>
            </CCol>

            <CCol sm={6} xl={4} xxl={3}>
              <Link to="/order">
                <div
                  className="bg-primary text-white dashboard_box5 rounded p-3 d-flex flex-column align-items-start shadow-sm"
                  style={{ minHeight: "150px" }}
                >
                  <div className="fs-4 fw-bold">
                    {dashboardData?.total_order || 0}
                  </div>
                  <div className="fs-6">Total Order</div>
                </div>
              </Link>
            </CCol>

            <CCol sm={6} xl={4} xxl={3}>
              <Link to="/order">
                <div
                  className="bg-success text-white dashboard_box6 rounded p-3 d-flex flex-column align-items-start shadow-sm"
                  style={{ minHeight: "150px" }}
                >
                  <div className="fs-4 fw-bold">{dashboardData?.todays_order}</div>
                  <div className="fs-6">New Order</div>
                </div>
              </Link>
            </CCol>

            {/* <CCol sm={6} xl={4} xxl={3}>
        <CWidgetStatsA
          color="info"
          value={
            <>
              $6.200{" "}
              <span className="fs-6 fw-normal">
                (40.9% <CIcon icon={cilArrowTop} />)
              </span>
            </>
          }
          title="Income"
          action={
            <CDropdown alignment="end">
              <CDropdownToggle
                color="transparent"
                caret={false}
                className="text-white p-0"
              >
                <CIcon icon={cilOptions} />
              </CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem>Action</CDropdownItem>
                <CDropdownItem>Another action</CDropdownItem>
                <CDropdownItem>Something else here...</CDropdownItem>
                <CDropdownItem disabled>Disabled action</CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          }
          chart={
            <CChartLine
              ref={widgetChartRef2}
              className="mt-3 mx-3"
              style={{ height: "70px" }}
              data={{
                labels: [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                ],
                datasets: [
                  {
                    label: "My First dataset",
                    backgroundColor: "transparent",
                    borderColor: "rgba(255,255,255,.55)",
                    pointBackgroundColor: getStyle("--cui-info"),
                    data: [1, 18, 9, 17, 34, 22, 11],
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                maintainAspectRatio: false,
                scales: {
                  x: {
                    border: {
                      display: false,
                    },
                    grid: {
                      display: false,
                      drawBorder: false,
                    },
                    ticks: {
                      display: false,
                    },
                  },
                  y: {
                    min: -9,
                    max: 39,
                    display: false,
                    grid: {
                      display: false,
                    },
                    ticks: {
                      display: false,
                    },
                  },
                },
                elements: {
                  line: {
                    borderWidth: 1,
                  },
                  point: {
                    radius: 4,
                    hitRadius: 10,
                    hoverRadius: 4,
                  },
                },
              }}
            />
          }
        />
      </CCol>
      <CCol sm={6} xl={4} xxl={3}>
        <CWidgetStatsA
          color="warning"
          value={
            <>
              2.49%{" "}
              <span className="fs-6 fw-normal">
                (84.7% <CIcon icon={cilArrowTop} />)
              </span>
            </>
          }
          title="Conversion Rate"
          action={
            <CDropdown alignment="end">
              <CDropdownToggle
                color="transparent"
                caret={false}
                className="text-white p-0"
              >
                <CIcon icon={cilOptions} />
              </CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem>Action</CDropdownItem>
                <CDropdownItem>Another action</CDropdownItem>
                <CDropdownItem>Something else here...</CDropdownItem>
                <CDropdownItem disabled>Disabled action</CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          }
          chart={
            <CChartLine
              className="mt-3"
              style={{ height: "70px" }}
              data={{
                labels: [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                ],
                datasets: [
                  {
                    label: "My First dataset",
                    backgroundColor: "rgba(255,255,255,.2)",
                    borderColor: "rgba(255,255,255,.55)",
                    data: [78, 81, 80, 45, 34, 12, 40],
                    fill: true,
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                maintainAspectRatio: false,
                scales: {
                  x: {
                    display: false,
                  },
                  y: {
                    display: false,
                  },
                },
                elements: {
                  line: {
                    borderWidth: 2,
                    tension: 0.4,
                  },
                  point: {
                    radius: 0,
                    hitRadius: 10,
                    hoverRadius: 4,
                  },
                },
              }}
            />
          }
        />
      </CCol>
      <CCol sm={6} xl={4} xxl={3}>
        <CWidgetStatsA
          color="danger"
          value={
            <>
              44K{" "}
              <span className="fs-6 fw-normal">
                (-23.6% <CIcon icon={cilArrowBottom} />)
              </span>
            </>
          }
          title="Sessions"
          action={
            <CDropdown alignment="end">
              <CDropdownToggle
                color="transparent"
                caret={false}
                className="text-white p-0"
              >
                <CIcon icon={cilOptions} />
              </CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem>Action</CDropdownItem>
                <CDropdownItem>Another action</CDropdownItem>
                <CDropdownItem>Something else here...</CDropdownItem>
                <CDropdownItem disabled>Disabled action</CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          }
          chart={
            <CChartBar
              className="mt-3 mx-3"
              style={{ height: "70px" }}
              data={{
                labels: [
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                  "January",
                  "February",
                  "March",
                  "April",
                ],
                datasets: [
                  {
                    label: "My First dataset",
                    backgroundColor: "rgba(255,255,255,.2)",
                    borderColor: "rgba(255,255,255,.55)",
                    data: [
                      78, 81, 80, 45, 34, 12, 40, 85, 65, 23, 12, 98, 34, 84,
                      67, 82,
                    ],
                    barPercentage: 0.6,
                  },
                ],
              }}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false,
                  },
                },
                scales: {
                  x: {
                    grid: {
                      display: false,
                      drawTicks: false,
                    },
                    ticks: {
                      display: false,
                    },
                  },
                  y: {
                    border: {
                      display: false,
                    },
                    grid: {
                      display: false,
                      drawBorder: false,
                      drawTicks: false,
                    },
                    ticks: {
                      display: false,
                    },
                  },
                },
              }}
            />
          }
        />
      </CCol> */}
          </CRow>

          <CRow className={props.className} xs={{ gutter: 4 }}>
            <CCol sm={6} xl={4} xxl={6}>
              <Form.Label>Shopkeeper Details</Form.Label>
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Shopkeepers</th>
                    <th>Amount</th>
                    <th>View Details</th>
                  </tr>
                </thead>
                <tbody>
                  {users?.data?.length > 0 ? (
                    users?.data?.map((user, index) => (
                      <tr key={user.id}>
                        <td>{index + 1}</td>
                        <td>
                          {user.f_name} {user?.l_name}
                        </td>
                        <td>Rs. {user?.User_Wallets?.[0]?.amount}</td>
                        <td>
                          <Link to="/wallet">View</Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No Users
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CCol>
          </CRow>
        </>
      ) : (
        <>


          <div className="row">
            <div className="col-xxl-9 col-xl-8 order-xl-1 order-2">
              <Banner />
              <Balance_Cards />
              <Recent_Activity_Feed />
              <Recent_Transaction />

              <div></div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-md-6 order-xl-2 order-1 mb-3">
              <div className="quick_acess_div">
                <Quick_Access />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

WidgetsDropdown.propTypes = {
  className: PropTypes.string,
  withCharts: PropTypes.bool,
};

export default WidgetsDropdown;
